/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Categorical attribute filter component
 * - allows user to update the data type of the attribute
 * - renders list of distinct category and allow user to include/exclude the category
 * - update the order of the category
 * Component will send the message which will be subscribed by the plot view to make the necessary change
 */

import React from 'react';
import RangeFilterComponent from './filter/RangeFilterComponent.js';
import DataTypeComponent from './DataTypeComponent.jsx';
import SortOrderComponent from './SortOrderComponent.jsx';
import NumericalColorPickerComponent from './NumericalColorPickerComponent.jsx';
import MissingValueComponent from './MissingValueComponent.jsx';
import NumericalIntervalComponent from './NumericalIntervalComponent.jsx';

import NameDescEditComponent from './NameDescEditComponent.jsx'
import DeleteAttributeComponent from './DeleteAttributeComponent.jsx'
import PlainButton from '../common/PlainButton';
import NumericDecimalsComponent from "./filter/NumericDecimalsComponent.jsx";
import FractionOptionsComponent from "./FractionOptionsComponent.jsx";

class AttributeEditComponent extends React.Component {
    constructor(props) {
        super(props);
        let Dyn = this.props.Dyn;
        var attributeObj = Dyn.dataSet.getAttributeByID( this.props.attributeId ),
            isFiltered = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeId ) !== null;

        // mediator.subscribe( "records:setCasesFiltered", this.updateCasesFiltered );
        // mediator.subscribe( "plot:containerResized", this.handleUnmountFilter );
        // mediator.subscribe( "toolBar:closeCurrentAttributeFilter", this.cleanFilter);
        /** very first time upon conversion the values are not available, so
         * so once the values width and start values available, update textbox
         */
        // mediator.subscribe( "records:numericIntervalsCalculated", this.numericIntervalsInitialized );

        // "plot:containerResized" - subscribe to it and handle the unmountFilter
        // attributeObj.stats.isNumeric() ? "numerical" : "categorical",
        this.state = {
            attributeObj: attributeObj,
            dataType: attributeObj.getDataType(true),
            sortOrder: attributeObj.isSortAscending ? "asc" : "desc",
            isFiltered: isFiltered,
            resetFilter: false,
            deleteAttribute: false,
            isNew: false
        };

        Dyn.mediator.subscribe( "records:setAttributeMetadata", (data) => {
            // update the Edit Attribute display if attribute ID matches
            if(this.props.attributeId === data.attribute.id) {
                this.setState({
                    attributeObj: data.attribute
                });
            }
        });
    }

    handleUnmountFilter = () => {

        // // Unmount it only if its smaller case card mode
        // if (!$("#chartArea").hasClass("slideLeft")){
        //     this.unmountFilter();
        //
        //     // Keep the state of the case card
        //     var record = {
        //         object: "filter",
        //         disableToggle: true
        //     };
        //     mediator.publish( "card:reinstateCaseCard", record );
        // }
    }

    cleanFilter = () => {
        // unmount the react filter component
        // this.unmountFilter();
    }

    unmountFilter = () => {
        // // Use the same Id as whats been used to render the
        // // react component for the container
        // var node = document.getElementById("caseDiv");
        //
        // mediator.remove( "records:setCasesFiltered", this.updateCasesFiltered );
        // mediator.remove( "plot:containerResized", this.handleUnmountFilter );
        // mediator.remove( "records:numericIntervalsCalculated", this.numericIntervalsInitialized);
        //
        // // It will unmount the component from the memory
        // // var unmountNode = ReactDOM.unmountComponentAtNode(node);
        // // console.log(unmountNode);
    }

    handleClose = (event) => {
        // unmount the react filter component
        // this.unmountFilter();

        this.props.onClose();

        // TODO - Revert back to the case cards - Check for selected attribute
        // var record = { object: "filter", caseCardScrollTop: this.props.caseCardScrollTop };
        // mediator.publish( "card:reinstateCaseCard", record );
    }

    // Show edit button
    // getEditButton = () => {
    //     var toolTip = "Edit Name and Description";
    //     if (this.state.attributeObj.isDerived){
    //         toolTip = "Edit Attribute Name, Description, and Formula";
    //     }
    //     return <PlainButton ref="editNameDescButton" className="tde-filter-edit" title={toolTip} onClick={this.handleNameDescEdit}><i className="tde-i tde-i-pencil"></i></PlainButton>;
    // }

    // Show delete button when isDerived===true
    getDeleteButton = () => {
        if(this.state.attributeObj.isDerived && !this.state.deleteAttribute) {
            return <React.Fragment>
                <div className="tde-name-desc-bottom-border tde-pt-3"></div>
                <div className={"tde-footer-btn-group tde-mb-3" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                    <button className="tde-mt-6 tde-mb-6 tde-btn-ok tde-s1 tde-btn tde-mx-2"
                onClick={this.handleDeleteAttribute}>{this.getLoc('Delete Attribute')}</button>
                </div>
            </React.Fragment>
        }
    }

    // To render the NameDescEditComponent when the edit button is clicked
    nameDescEditComponent = () => {
        return <NameDescEditComponent
            Dyn = {this.props.Dyn}
            autoFocus = {true}
            handleClose={this.handleNameDescEditClose} isNew={ this.state.isNew } attributeObj={ this.state.attributeObj} reduceCaseCardWidth = {this.props.reduceCaseCardWidth} saveOnBlur />;
    }

    deleteAttributeComponent = () => {
        if (this.state.deleteAttribute) {
            return <React.Fragment>
                <div className="tde-divider-bottom tde-pt-3"></div>
                <DeleteAttributeComponent
                    Dyn = {this.props.Dyn}
                    handleDeleteAttributeClose={this.handleDeleteAttributeClose} attributeObj={ this.state.attributeObj } reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
            </React.Fragment>
        }
    }

    handleDeleteAttribute = () => {
        this.setState({
            deleteAttribute: true
        }, () => {
            if(this.lastElement) {
                this.lastElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    // Set this.state.editAttributeNameDesc value to true to render NameDescEditComponent
    // handleNameDescEdit = (event) => {
    //     this.state.editAttributeNameDesc = true;
    //     this.forceUpdate();
    // }

    // Callback function which will be called when Save/Cancel button is clicked at NameDescEditComponent
    handleNameDescEditClose = (isSave, val) => {
        let Dyn = this.props.Dyn;
        if(isSave) {
            Dyn.dataSet.updateMetadataField({
                id: this.state.attributeObj.id,
                name: val.attrName,
                longName: val.attrLongName,
                formulaString: val.formulaString
            });
            // To trigger the range change on the update of the formula
            /* this.setState({
                resetFilter: true});*/
        }
        this.state.editAttributeNameDesc = false;
        this.forceUpdate();
        // To focus back the edit button
        //this.refs.editNameDescButton.focus();
    }

    handleDeleteAttributeClose = (isDelete, val) => {
        let Dyn = this.props.Dyn;
        if(isDelete) {
            Dyn.dataSet.deleteMetadataField({
                id: this.state.attributeObj.id
            });
            // close the edit attribute filter
            this.handleClose();
        } else {
            this.state.deleteAttribute = false;
            this.forceUpdate();
        }
    }

    /**
     * handle dataType change, rerender the component
     * updating the state should take care of it.
     */
    dataTypeChange = (options) => {
        let Dyn = this.props.Dyn;

        // on state change, reset the filter for the relevent attribute.
        // updated the dataType
        if ( this.state.dataType !== options.value ) {
            // publish the message to reset the filter applied for the attribute
            // mediator.publish( "records:caseFilterByAttribute", {
            //     "attributeID": this.props.attributeId
            // });
            this.filterStateChange({
                isFiltered: false,
                component: 'reset'
            });
            // Get the updated attribute Obj
            var attributeObj = Dyn.dataSet.getAttributeByID( this.props.attributeId );

            this.setState({
                attributeObj: attributeObj,
                dataType: options.value
            });
        }

        // To let the parent component know about datatype change
        if(this.props.onAttributeDataTypeChange) {
            this.props.onAttributeDataTypeChange({
              "attributeID": this.state.attributeObj.id,
              "dataType": options.value
            });
        }
    }

    /**
     * handle sort order change for the attribute, regardless type
     */
    sortOrderChange = (value) => {
        let Dyn = this.props.Dyn;
        // on state change, reset the filter for the relevent attribute.
        // updated the sortOrder
        var attributeObj = Dyn.dataSet.getAttributeByID( this.props.attributeId );

        this.setState({
            attributeObj: attributeObj,
            sortOrder: value
        });

        // To let the parent component know about sor order change
        if(this.props.onAttributeSortOrderChange) {
            this.props.onAttributeSortOrderChange({
              "attributeID": this.state.attributeObj.id,
              "sortOrder": value
            });
        }
    }

    /**
     * applied global reset filter, when user clicks on the toolbar reset
     * filter - if attribute filter is open reset it and also update the state
     * of the reset filter button.
     */
    updateCasesFiltered = ( args ) => {
        let Dyn = this.props.Dyn;

        var attributeObj = Dyn.dataSet.getAttributeByID(this.props.attributeId);
        if ('resetAll' in args && args.resetAll) {
            this.setState({
                resetFilter: true,
                isFiltered: false,
                attributeObj: attributeObj
            });
        } else {
            // to get updated stats and pass it to sub component
            this.setState({
                resetFilter: false,
                isFiltered: true,
                attributeObj: attributeObj
            });
        }
    }

    /**
     * handle the messaging from the child components on change
     */
    filterStateChange = (options) => {
        let Dyn = this.props.Dyn;

        // For categorical attribute filter state change
        if(options.dataType === 'categorical' || options.component === 'reset') {
            var props = {
                attributeID: this.state.attributeObj.id
            };
            if(options.isFiltered) {
                props.categories = options.filtered
            }
            this.props.onAttributeCaseFilter(props);
        } else if (options.dataType === 'numerical') {
            if(options.subType == 'date' || options.subType == 'time' || options.subType == 'datetime' ||
                options.subType == 'month' || options.subType == 'dayOfWeek' || options.component=='numeric-range' ||
                options.subType == 'monthYear' || options.subType == 'yearMonth') {
                this.props.onAttributeCaseFilter({
                  attributeID: this.state.attributeObj.id,
                  numeric:{
                    min: options.filtered.min,
                    max: options.filtered.max
                  }
                });
            } else if(options.component === 'numeric-interval') {
                var args = {
                  attributeID: this.state.attributeObj.id,
                  numericIntervalWidth: options.numericInterval.width,
                  numericIntervalStart: options.numericInterval.start
                };
                this.props.onAttributeNumericIntervalsUpdated(args);

                // handle locally
                this.numericIntervalsInitialized(args);
            }
            Dyn.assert( options.component !== 'numeric-decimals',"use dataTypeOptionsChange()");
            // else if(options.component === 'numeric-decimals') {
            //     //pass message to plot on the update of the decimal places for attribute
            //     this.props.onAttributeNumericDecimalsUpdated({
            //       attributeID: this.state.attributeObj.id,
            //       numericDecimals: options.numericDecimals
            //     });
            // }
            // mediator.publish( "records:caseFilterByAttribute",);
        }

        // if(options.component === 'numeric-decimals') {
        //     // Don't execute the following code when numeric-decimals component values are change
        //     return;
        // }

        var isFiltered = Dyn.dataSet.caseFilter.getAttributeFilter( this.props.attributeId ) !== null,
            attributeObj = Dyn.dataSet.getAttributeByID( this.props.attributeId );

        this.setState({
            attributeObj: attributeObj,
            isFiltered: isFiltered
        });

        if ( options && options.isFiltered === false ) {
            this.setState({
                resetFilter: true,
                attributeObj: attributeObj
            });
        } else {
            this.setState({
                resetFilter: false,
                attributeObj: attributeObj
            });
        }
    }

    dataTypeOptionsChange = ( options ) => {
        if( options.component === 'numeric-decimals' ) {
            // message to dataset: updated decimal places for attribute
            this.props.onAttributeNumericDecimalsUpdated({
                attributeID: this.state.attributeObj.id,
                numericDecimals: options.numericDecimals,
                hasTrailingZeros: options.hasTrailingZeros,
            });
        } else if( options.component === 'fraction-options' ) {
            // message to dataset: updated data format for attribute
            this.props.onAttributeNumericDecimalsUpdated({
                attributeID: this.state.attributeObj.id,
                formatString: options.formatString
            });
        } else {
            this.props.Dyn.assert( false, "unknown component"+options?.component );
        }
    }

    numericalColorPickerComponent = () => {

        //if ( !this.state.dataType.includes("categorical") ) {
        if ( this.state.dataType.indexOf("categorical") === -1 ) {
            return <NumericalColorPickerComponent
                Dyn = {this.props.Dyn}
                attributeObj={ this.state.attributeObj } reduceCaseCardWidth = { this.props.reduceCaseCardWidth }/>
        }

    }

    missingValueComponent = () => {
       if ( this.state.attributeObj.statsPreFilter.missingCaseCount >= 1 ) {
            return <MissingValueComponent
                Dyn = {this.props.Dyn}
                attributeObj={ this.state.attributeObj } reduceCaseCardWidth = { this.props.reduceCaseCardWidth }/>
       }
    }

    numericIntervalsInitialized = ( args ) => {
        // Only update the state when previous state is not same as new values.
        if (args.attributeID === this.state.attributeObj.id && (this.state.numericIntervalWidth !== args.numericIntervalWidth || this.state.numericIntervalStart !== args.numericIntervalStart)){
            this.setState({
                numericIntervalWidth: args.numericIntervalWidth,
                numericIntervalStart: args.numericIntervalStart,
                maxStartValueAllowed: this.state.attributeObj.statsPreFilter.min
            });
        }
    }

    dataTypeOptionsComponents = () => {
        // get the options specific to the selected data type
        switch( this.state.dataType ) {
            case "categorical:numericIntervals":
                return <NumericalIntervalComponent
                    Dyn = {this.props.Dyn}
                    handleChange={this.filterStateChange}
                    numericIntervalWidth={ this.state.numericIntervalWidth }
                    numericIntervalStart={ this.state.numericIntervalStart}
                    maxStartValueAllowed= { this.state.maxStartValueAllowed }
                    attributeObj={ this.state.attributeObj }
                    reduceCaseCardWidth = { this.props.reduceCaseCardWidth }
                />;
            case "numerical" :
            case "numerical:extractedNumber" :
            case "numerical:duration" :
            case "numerical:durationHM" :
            case "numerical:year" :
                return <NumericDecimalsComponent
                    Dyn={this.props.Dyn}
                    key="numericalDecimalComponent"
                    handleChange={this.dataTypeOptionsChange}
                    attributeObj={this.state.attributeObj}
                    reduceCaseCardWidth={this.props.reduceCaseCardWidth}
                />;
            case "numerical:fraction" :
                return <FractionOptionsComponent
                    Dyn={this.props.Dyn}
                    //key="numericalDecimalComponent"
                    handleChange={this.dataTypeOptionsChange}
                    attributeObj={this.state.attributeObj}
                    reduceCaseCardWidth={this.props.reduceCaseCardWidth}
                />;
        }
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }

    // To listen the keypress on the component
    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }

    componentDidMount = () => {
        this.refs.closeButton.focus();
    }

    render = () => {

        // again update the state?

        // if attribute name and long name not same
        var longName;
        if (this.state.attributeObj.name !==this.state.attributeObj.longName) {
            longName = (<div title={ this.state.attributeObj.longName } className="subText">Description: <span dangerouslySetInnerHTML={{ __html: this.state.attributeObj.longName }}></span></div>);
        }

        // render the filter component
        return (
            <div className="tde-fill" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
                <div className="tde-sliding-panel-header tde-divider-bottom">
                    <div><span
                        className="tde-ml-2 tde-h6 tde-font-weight-bold"
                        role="heading"
                        aria-level="1">{ this.getLoc('ATTRIBUTE SETTINGS CARD') }</span></div>
                    <PlainButton className="tde-mx-2 tde-close-attr-settings" ref="closeButton" title={this.getLoc("Close")} aria-label={this.getLoc('Close Attribute Settings')} onClick={this.handleClose}><i className="tde-i tde-i-remove"></i></PlainButton>
                </div>

                <div className="tde-sliding-panel-body tde-attribute-add-edit-body tde-card-content-bg-color">
                    {/* <div className="tde-attribute-meta-component">
                        <div className="tde-floating-btn-group">
                        { this.getEditButton() }
                        { this.getDeleteButton() }
                        </div>
                        <div className="tde-attribute-name" title={ this.state.attributeObj.name }>{ this.getLoc('Name') }: <span dangerouslySetInnerHTML={{ __html: this.state.attributeObj.name }}></span></div>
                        <div title={ this.state.attributeObj.longName } className="tde-sub-text tde-attribute-desc">{ this.getLoc('Description') }: <span dangerouslySetInnerHTML={{ __html: this.state.attributeObj.longName }}></span></div>
                        { this.state.attributeObj.isDerived &&
                            <div title={ this.state.attributeObj.formulaString } className="tde-sub-text tde-attribute-desc">{ this.getLoc('Formula') }: { this.state.attributeObj.formulaString }</div>
                        }
                    </div> */}
                    <div>
                        { this.nameDescEditComponent() }

                        <DataTypeComponent
                            Dyn = {this.props.Dyn}
                            handleChange={this.dataTypeChange} dataType= {this.state.dataType} attributeObj={ this.state.attributeObj } reduceCaseCardWidth = { this.props.reduceCaseCardWidth }/>
                        { this.dataTypeOptionsComponents() }
                        <SortOrderComponent
                            Dyn = {this.props.Dyn}
                            handleChange={this.sortOrderChange} sortOrder={this.state.sortOrder} attributeObj={ this.state.attributeObj } reduceCaseCardWidth = { this.props.reduceCaseCardWidth }/>
                        { this.missingValueComponent() }
                        { this.numericalColorPickerComponent() }
                    </div>
                    <RangeFilterComponent
                        Dyn={this.props.Dyn}
                        type={this.state.dataType}
                        resetFilter={this.state.resetFilter}
                        isFiltered={this.state.isFiltered}
                        attribute={this.state.attributeObj}
                        reduceCaseCardWidth={this.props.reduceCaseCardWidth}
                        handleChange={this.filterStateChange}
                    />
                    {/* Model Forms */}
                    { this.getDeleteButton() }
                    { this.deleteAttributeComponent() }
                    <div ref={ele => this.lastElement = ele}></div>
                </div>
            </div>
        );
    }
}

export default AttributeEditComponent
